import { observeFooterMeasure } from './monolyt-footer-measure.js?v=5fa0219cbf4cdff00cbf1e8692fd8add40177d14e31991e32bf9efdc2d2f08c0';

/* Balance wrapped footer payment rows without changing their order or SVG sizes. */
class MonolytPaymentIcons extends HTMLElement {
  connectedCallback() {
    this.cleanup?.();
    if (!this.closest('.monolyt-pageify-shared-footer')) return;
    const list = this.querySelector('.payment-icons__list');
    if (!list) return;

    const mobile = window.matchMedia('(max-width: 749px)');
    const clear = () => {
      list.style.removeProperty('--monolyt-payment-row-width');
      list.style.removeProperty('--monolyt-payment-item-width');
    };
    const measure = () => {
      if (getComputedStyle(list).flexWrap === 'nowrap') {
        clear();
        return;
      }
      const icons = [...list.querySelectorAll('.payment-icons__item .icon')];
      const available = this.clientWidth;
      const width = Math.max(0, ...icons.map(icon => icon.getBoundingClientRect().width));
      if (!available || !width || !icons.length) return;
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      const capacity = Math.max(1, Math.floor((available + gap) / (width + gap)));
      const rows = Math.ceil(icons.length / capacity);
      const columns = Math.ceil(icons.length / rows);
      const set = (name, value) => {
        if (list.style.getPropertyValue(name) !== value) list.style.setProperty(name, value);
      };
      set('--monolyt-payment-item-width', `${width}px`);
      set('--monolyt-payment-row-width', `${columns * (width + gap) - gap}px`);
    };
    this.cleanup = observeFooterMeasure({
      host: this,
      elements: [this],
      mediaQuery: mobile,
      measure,
      cleanup: clear,
    });
  }

  disconnectedCallback() {
    this.cleanup?.();
  }
}

if (!customElements.get('monolyt-payment-icons')) {
  customElements.define('monolyt-payment-icons', MonolytPaymentIcons);
}
